module.exports = __webpack_public_path__ + "img/717.a4721382.png";